import { appstore, googleplay } from '@/utils/imagepath';
import React from 'react';

const HomeEditBannerDownloadApp = ({ themeData }: any) => {
  return (
    <div
      className="section-app app-download-blk"
      style={{
        background: `#${themeData?.theme_5?.home?.section_8?.bg_color}`,
      }}
    >
      <div className="container">
        <div className="row">
          <div className="app-content col-md-6 aos-init" data-aos="zoom-in-up">
            
              <h2 style={{
                      color: `#${themeData?.theme_5?.home?.section_8?.h2color}`
                    }}>{themeData?.theme_5?.home?.section_8?.title}</h2>
              <p style={{
                      color: `#${themeData?.theme_5?.home?.section_8?.paracolor}`
                    }}>{themeData?.theme_5?.home?.section_8?.paragraph}</p>
              <ul className="pt-5">
                <li>
                  <a
                    target="_blank"
                    className="hvr-float-shadow imggbg"
                    href={
                      themeData?.theme_5?.home?.section_8?.mobile_link_section
                        ?.ios_link
                    }
                  >
                    <img
                      src={appstore}
                      alt="appstore"
                      className="img img-fluid"
                    />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    className="hvr-float-shadow imggbg2"
                    href={
                      themeData?.theme_5?.home?.section_8?.mobile_link_section
                        ?.android_link
                    }
                  >
                    <img
                      src={googleplay}
                      alt="appstore"
                      className="img img-fluid"
                    />
                  </a>
                </li>
              </ul>
          </div>
          <div className="app-img col-md-6">
            <img
              src={themeData?.theme_5?.home?.section_8?.banner}
              className="img-fluid aos-init"
              alt="appdownload"
              data-aos="zoom-in-up"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeEditBannerDownloadApp;
